import { RefObject, useEffect } from "react";

export const useOutsideAlerter = (ref: RefObject<HTMLElement>, onClickOutside?: () => void) => {
  useEffect(() => {
    const handleClickOutside = (event: globalThis.MouseEvent) => {
      if (
        ref.current &&
        ref?.current?.contains &&
        !ref?.current?.contains(event.target as Node) &&
        onClickOutside
      ) {
        onClickOutside();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
};
